import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import SelectFieldSeccionesComponent from '../../secciones/components/SelectFieldSecciones';
import { allFamiliaresAction } from '../FamiliaresAction';
import { ALL_FAMILIARES, PARAMS_FAMILIARES } from '../FamiliaresReducer';

const FiltrosFamiliaresComponent = () => {
  const dispatch = Redux.useDispatch();

  const familiaresStore = Redux.useSelector((state) => state.familiares);

  const getData = async (p) => {
    if (!p) {
      dispatch({
        type: ALL_FAMILIARES,
        payload: { data: [] },
      });
    }
    const payload = {
      ...familiaresStore.params,
      ...p,
    };
    dispatch({ type: PARAMS_FAMILIARES, payload });
    await allFamiliaresAction(dispatch, payload);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Typography variant="h6" color="initial">
            FILTROS
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <SelectFieldSeccionesComponent
            id="filtroSecciones"
            value={familiaresStore.params.idSeccion}
            onChange={(idSeccion) => {
              // if (!idSeccion) {
              //   dispatch({
              //     type: ALL_FAMILIARES,
              //     payload: { data: [] },
              //   });
              //   setDataParams({ idSeccion: null });
              //   return;
              // }

              getData({ idSeccion });
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FiltrosFamiliaresComponent;
